var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallOfDuty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29216",
    "data-name": "Group 29216",
    transform: "translate(509 10118)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -509, -10118)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_50750",
    "data-name": "Path 50750",
    d: "M7.283,25.17a8.59,8.59,0,0,0,.938,2.439H5.427a2.067,2.067,0,0,1-.522-.061,2.4,2.4,0,0,1-1.789-1.638A2.238,2.238,0,0,1,3,25.182V19.457a1.217,1.217,0,0,1,1.214-1.214H5.34V16.688c0-2.475.724-4.391,3.12-4.688h.793a11.8,11.8,0,0,0-1.4,4.688v5.46H7.86a5.793,5.793,0,0,0-.613,2.427A5.319,5.319,0,0,0,7.283,25.17Z",
    transform: "translate(-491.381 -10105.478)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50751",
    "data-name": "Path 50751",
    d: "M38.955,25.17a8.59,8.59,0,0,1-.938,2.439h2.795a2.067,2.067,0,0,0,.522-.061,2.4,2.4,0,0,0,1.789-1.638,2.236,2.236,0,0,0,.115-.728V19.457a1.217,1.217,0,0,0-1.214-1.214H40.9V16.688c0-2.475-.724-4.391-3.12-4.688h-.793a11.8,11.8,0,0,1,1.4,4.688v5.46h-.006a5.793,5.793,0,0,1,.613,2.427A5.131,5.131,0,0,1,38.955,25.17Z",
    transform: "translate(-498.856 -10105.478)",
    fill: "#90a4ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50752",
    "data-name": "Path 50752",
    d: "M32.4,14.526v5.46H32.4a23.427,23.427,0,0,0-1.842-3.034c-1.232-1.82-5.173-3.836-9.859-3.836-5.43,0-8.622,2.427-9.854,4.247A23.514,23.514,0,0,0,9,20.4V14.526a11.356,11.356,0,0,1,2.353-6.917,11.787,11.787,0,0,1,18.7-.006,11.519,11.519,0,0,1,1.342,2.245A11.222,11.222,0,0,1,32.4,14.526Z",
    transform: "translate(-492.701 -10103.498)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50753",
    "data-name": "Path 50753",
    d: "M32.331,22.117a23.485,23.485,0,0,0-1.866-3.047,11.753,11.753,0,0,1-1.339-4.67A1.563,1.563,0,0,0,27.575,13L13.4,13a1.56,1.56,0,0,0-1.561,1.419A10.188,10.188,0,0,1,10.5,19.07,23.59,23.59,0,0,0,8.63,22.117,5.707,5.707,0,0,0,8,24.555a7,7,0,0,0,.768,2.986,4.056,4.056,0,0,0,3.6,2.5c2.359,0,2.465,2.785,2.608,4.669.044.616.044,1.128.044,1.427,0,1.069,5.46,1.063,5.46,1.063s5.46.006,5.46-1.063c0-.3,0-.81.044-1.426.144-1.883.25-4.669,2.608-4.669a4.056,4.056,0,0,0,3.6-2.5,7.007,7.007,0,0,0,.768-2.987A5.707,5.707,0,0,0,32.331,22.117Z",
    transform: "translate(-492.481 -10105.698)",
    fill: "#d7ccc8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50754",
    "data-name": "Path 50754",
    d: "M25.668,34.776a.86.86,0,0,1-.934.9c-.733,0-1.267-1.222-1.4-1.736,0,.644-.534,1.736-1.4,1.736a.86.86,0,0,1-.934-.9c0-1.222,1.467-3.6,2.334-3.795A5.677,5.677,0,0,1,25.668,34.776Z",
    transform: "translate(-495.34 -10109.653)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50755",
    "data-name": "Path 50755",
    d: "M18.019,22.744a3.377,3.377,0,0,0-4.626,2.262c-1.02,2.964.157,4.368,1.1,4.68,2.509.7,4.626-.234,5.331-2.574a3.519,3.519,0,0,0-1.8-4.368Z",
    transform: "translate(-493.581 -10107.783)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50756",
    "data-name": "Path 50756",
    d: "M28,22.744a3.521,3.521,0,0,0-1.8,4.368c.706,2.34,2.822,3.276,5.331,2.574.941-.312,2.117-1.716,1.1-4.68A3.376,3.376,0,0,0,28,22.744Z",
    transform: "translate(-496.44 -10107.783)",
    fill: "#263238"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallOfDuty);
export default __webpack_public_path__ + "static/media/callOfDuty.eade118429a26cd660cdfec87b70288e.svg";
export { ForwardRef as ReactComponent };